import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../store';
import { selectProfileBusy } from '../../store/profile/profile.state';
import { filter, map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class LoginGuard {

    constructor(private store: Store<AppState>) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        // Wait for the initial profile bootstrap to finish before allowing the first
        // route activation. Returning the initial busy=true emission cancels navigation
        // and leaves the shell blank until the user manually refreshes.
        return this.store.select(selectProfileBusy).pipe(
            filter(busy => !busy),
            take(1),
            map(() => true)
        );
    }
}
